export default function CTA() {
  // Real ad creatives from our render pipeline (public/feature-renders). All the
  // finished ads (the raw sunglasses-on-gray upload is intentionally excluded —
  // it lives in the hero story). A full set keeps the marquee dense with no gap.
  const floatingImages = [
    '/feature-renders/moodboard_3291e2b4e4-1ddd49ec.webp',
    '/feature-renders/moodboard_5c47495010-3ab99e30.webp',
    '/feature-renders/moodboard_6ae6c75ccb-40b4b79c.webp',
    '/feature-renders/moodboard_86baf0c73b-bd30d591.webp',
    '/feature-renders/moodboard_aa60f3c1ff-732149e3.webp',
    '/feature-renders/moodboard_95b559f834-26ca870a.webp',
    '/feature-renders/moodboard_274be8f757-11b74cb9.webp',
    '/feature-renders/moodboard_gen_4182429a62-8179aee0.webp',
    '/feature-renders/moodboard_fc98c1fa54-18eea65d.webp',
    '/feature-renders/moodboard_231092c5ea-a2cf4a90.webp',
    '/feature-renders/moodboard_12f8516db9-7934695a.webp',
  ];

  return (
    <section className="py-24 md:py-32 bg-white overflow-hidden">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-light text-primary text-xs font-semibold tracking-wider uppercase mb-6">
            <i className="ri-rocket-line" />
            Get Started
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-dark leading-[1.1] tracking-tight mb-5">
            Everyone else hands you an image.
            <br />
            <span className="text-primary">We run your whole ad engine.</span>
          </h2>
          <p className="text-base md:text-lg text-dark-muted mb-8 leading-relaxed">
            Research your competitors, generate winning creative, and publish it,
            all in one place. Start free and see your first ads in seconds.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href="/auth/sign-up"
              className="inline-flex items-center gap-3 px-8 py-4 bg-primary hover:bg-primary-hover text-white text-base font-bold rounded-full transition-all group shadow-lg shadow-primary/20"
            >
              Start Free
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="/try"
              className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-dark-muted/25 text-dark text-base font-semibold transition-all hover:border-primary/40"
            >
              Try it free
              <i className="ri-magic-line text-primary" />
            </a>
          </div>
          <p className="text-sm text-dark-muted/60 mt-4">
            No card required · 20 free credits to start · Upgrade anytime.
          </p>
        </div>

        {/* Floating Images */}
        <div className="relative h-[300px] md:h-[400px] overflow-hidden">
          <div className="flex gap-5 absolute left-0 animate-[marquee_30s_linear_infinite]" style={{ width: 'max-content' }}>
            {[...floatingImages, ...floatingImages].map((img, i) => (
              <div
                key={i}
                className="w-[200px] md:w-[250px] h-[280px] md:h-[350px] rounded-2xl overflow-hidden flex-shrink-0 shadow-lg hover:shadow-xl transition-shadow"
              >
                <img
                  src={img}
                  alt={`Example post ${(i % 5) + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}